<template>
  <div class=" container-bg">
    <div class="container py-5 ">
      <form
        class="applyForm  border border-info rounded"
        @submit.prevent="submit"
      >
        <div class="form">
          <h1 class="mt-4 pt-3  text-center h1--title">Solicitud de Empleo</h1>
          <p class="text-center mt-2 mb-2 textform">
            Por favor completar la informacion solicitada
          </p>
          <div class="panel mt-20">
            <div>
              <label for="">Seleccionar Vacante</label>
              <select
                class="mb-2 form-control"
                aria-label="Default select"
                v-model="solicitud.vacanteId"
                placeholder="Seleccione la vacante"
              >
                <option
                  v-for="vacant in listVacants"
                  :value="vacant.id"
                  :key="vacant.id"
                >
                  <template v-if="vacant.id != null">
                    {{ vacant.departamento }} - {{ vacant.nombre }}
                  </template>
                </option>
              </select>
            </div>
            <div>
              <h2 class="h2--title mt-4">Datos Personales</h2>
              <hr />
              <b-row>
                <b-col md="6">
                  <div>
                    <div>
                      <label for="cedula">
                        <input
                          id="cedula"
                          type="radio"
                          v-model="solicitud.tipoDocumento"
                          name="documento"
                          value="Cedula"
                          ref="tipoDocument"
                        />
                        <span class="ml-2">Cédula</span>
                      </label>
                    </div>
                    <div>
                      <label for="pasaporte">
                        <input
                          id="pasaporte"
                          type="radio"
                          v-model="solicitud.tipoDocumento"
                          name="documento"
                          size="sm"
                          value="Pasaporte"
                          ref="tipoDocument"
                        />
                        <span class="ml-2">Pasaporte</span>
                      </label>
                    </div>
                    <div>
                      <label>No. Documento</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="solicitud.documento"
                        data-vv-validate-on="blur|input"
                        data-vv-name="documento"
                        v-validate="'required|validDocument:tipoDocument'"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has('documento')"
                        >{{ errors.first("documento") }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <div class="my-2 ">
                      <label>Nombres</label>
                      <input
                        class="form-control"
                        type="text "
                        v-model="solicitud.nombre"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        data-vv-name="nombre"
                      />

                      <span
                        class="text-danger fs-6"
                        v-show="errors.has('nombre')"
                        >{{ errors.first("nombre") }}</span
                      >
                    </div>
                  </div>

                  <div class="my-2">
                    <label>Apellidos</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="solicitud.apellido"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="apellidos"
                    />

                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('apellidos')"
                      >{{ errors.first("apellidos") }}</span
                    >
                  </div>

                  <div class="my-2">
                    <label>Correo</label>
                    <input
                      class="form-control"
                      type="email"
                      v-model="solicitud.correo"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="correo"
                    />

                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('correo')"
                      >{{ errors.first("correo") }}</span
                    >
                  </div>

                  <div class="sexo px-2 py-2">
                    <p>Sexo</p>
                    <label for="m">
                      <input
                        id="m"
                        type="radio"
                        v-model="solicitud.sexo"
                        name="m"
                        value="M"
                      />
                      <span class="ml-2">M</span>
                    </label>
                    <label for="f" class="ml-4">
                      <input
                        id="f"
                        type="radio"
                        v-model="solicitud.sexo"
                        name="f"
                        value="F"
                      /><span class="ml-2">F</span>
                    </label>
                  </div>
                  <div>
                    <div>
                      <label class="">Tipo de Sangre</label>
                      <select
                        class="mb-2 form-control"
                        aria-label="Default select"
                        v-model="solicitud.tipoSangre"
                        placeholder=""
                      >
                        <option
                          v-for="tipo in opcionesSangre"
                          :value="tipo.text"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label class="">Estado Civil</label>
                    <select
                      class="mb-2 form-control"
                      aria-label="Default select"
                      v-model="solicitud.estadoCivil"
                      placeholder=""
                    >
                      <option
                        v-for="tipo in opcionesEstadoCivil"
                        :value="tipo.text"
                        :key="tipo.id"
                      >
                        {{ tipo.text }}
                      </option>
                    </select>
                  </div>
                </b-col>

                <b-col md="6">
                  <div>
                    <label class="">Fecha de Nacimiento</label>
                    <b-form-datepicker
                      v-validate="'required|validFechaNacimiento'"
                      data-vv-validate-on="blur|input"
                      locale="es"
                      placeholder="Fecha de nacimiento"
                      data-vv-name="date"
                      v-model="solicitud.fechaNacimento"
                      :max="new Date()"
                    >
                    </b-form-datepicker>
                    <div>
                      <span class="text-danger fs-6" v-show="errors.has('date')"
                        >Este campo es requerido</span
                      >
                    </div>
                  </div>
                  <div class="my-2">
                    <label>Lugar de Nacimiento</label>
                    <input
                      class=" form-control"
                      type="text "
                      v-model="solicitud.lugarNacimiento"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="lugar"
                    />
                    <div>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has('lugar')"
                        >{{ errors.first("lugar") }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <label class="">País</label>
                    <select
                      class="mb-2 form-control"
                      aria-label="Default select"
                      v-model="solicitud.pais"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="pais"
                    >
                      <option
                        v-for="tipo in sortedCountries"
                        :value="tipo"
                        :key="tipo.id"
                      >
                        {{ tipo }}
                      </option>
                    </select>
                    <div>
                      <span class="text-danger fs-6" v-show="errors.has('pais')"
                        >Este campo es requerido</span
                      >
                    </div>
                  </div>
                  <div>
                    <label class="">Nacionalidad</label>
                    <select
                      class="mb-2 form-control"
                      aria-label="Default select"
                      v-model="solicitud.nacionalidad"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="nacionalidad"
                    >
                      <option
                        v-for="tipo in arrayNacionalidad"
                        :value="tipo.toUpperCase()"
                        :key="tipo.id"
                      >
                        {{ tipo }}
                      </option>
                    </select>
                    <div>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has('nacionalidad')"
                        >Este campo es requerido</span
                      >
                    </div>
                  </div>
                  <div class="my-2">
                    <label> Celular</label>
                    <input
                      class=" form-control"
                      type="text "
                      v-model="solicitud.celular"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="celular"
                    />

                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('celular')"
                      >Este campo es requerido</span
                    >
                  </div>
                  <div>
                    <label>Teléfono</label>
                    <input
                      class="my-2 form-control"
                      type="text "
                      v-model="solicitud.telefono"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="telefono"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('telefono')"
                      >Este campo es requerido</span
                    >
                  </div>
                  <div>
                    <label>Dirección</label>
                    <input
                      class="my-2 form-control"
                      type="text"
                      v-model="solicitud.direccion"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="direccion"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('direccion')"
                      >Este campo es requerido</span
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="familia">
              <br />
              <h2 class="h2--title mt-4">Miembros de la familia</h2>

              <div
                class="input-familia"
                v-for="(input, k) in familias"
                :key="k"
              >
                <hr />
                <b-row>
                  <b-col md="4" class="">
                    <div>
                      <label>Nombre y Apellido</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="input.nombreCompleto"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`familiaNam${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`familiaNam${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div class="my-2">
                      <label>Edad</label>
                      <input
                        class="form-control"
                        type="number"
                        min="0"
                        v-model.number="input.edad"
                        placeholder=""
                        max="120"
                        v-validate="'required|between:0,120'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`familiaNum${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`familiaNum${k}`)"
                        >El campo es obligatorio y numérico</span
                      >
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div>
                      <label class="">Parentesco</label>
                      <select
                        class="form-control"
                        aria-label="Default select"
                        v-model="input.parentesco"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`familiaParen${k}`"
                      >
                        <option
                          v-for="tipo in opcionesPatentesco"
                          :value="tipo.text"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`familiaParen${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div class="my-2">
                      <label class="">Ocupación</label>
                      <input
                        class=" form-control"
                        type="text"
                        min="0"
                        v-model="input.ocupacion"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`familiaOcupation${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`familiaOcupation${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                  </b-col>
                  <b-col md="4">
                    <label class="">Fecha de Nacimiento</label>
                    <b-form-datepicker
                      locale="es"
                      placeholder="Fecha de nacimiento"
                      type="date"
                      v-model="input.fechaNacimiento"
                      :max="new Date()"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      :data-vv-name="`familiaFechaNacimiento${k}`"
                    >
                    </b-form-datepicker>
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has(`familiaFechaNacimiento${k}`)"
                      >El campo es obligatorio</span
                    >
                    <b-button
                      variant="outline-success"
                      class="float-right mt-2 btn btn-outline-success"
                      v-if="k == 0"
                      @click="add('inputsFamilia')"
                    >
                      Agregar
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      class="float-right mt-2 btn btn-outline-danger"
                      v-else-if="k > 0"
                      @click="remove('inputsFamilia', k)"
                    >
                      Remover
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- --------- -->
            <!-- Education -->
            <!-- --------- -->
            <div class="eduacion">
              <h2 class="h2--title mt-4">Educación</h2>
              <hr />
              <div
                class="input-Educacion"
                v-for="(input, k) in educacion"
                :key="k"
              >
                <b-row>
                  <b-col md="4">
                    <div>
                      <label class="">Nivel Academico</label>
                      <select
                        class="form-control"
                        aria-label="Default select"
                        v-model="input.nivelAcademico"
                      >
                        <option
                          v-for="tipo in opcionesNivel"
                          :value="tipo.text"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                    </div>

                    <div class="my-2">
                      <label>Nombre de la Institución</label>
                      <input
                        class=" form-control"
                        type="text"
                        v-model="input.nombreInstitucion"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`instituto${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`instituto${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>

                  <b-col md="4">
                    <div>
                      <label class="">Fecha de inicio</label>
                      <b-form-datepicker
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        locale="es"
                        placeholder="Fecha de inicio"
                        :data-vv-name="`fechaInicioEducation${k}`"
                        v-model="input.fechaInicio"
                      >
                      </b-form-datepicker>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`fechaInicioEducation${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div class="mt-2">
                      <label class="">Fecha de final</label>

                      <b-form-datepicker
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        locale="es"
                        placeholder="Fecha de inicio"
                        :data-vv-name="`fechaFinalEducation${k}`"
                        v-model="input.fechaFinal"
                      >
                      </b-form-datepicker>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`fechaFinalEducation${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="">
                      <label>Título Obtenido</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="input.titulo"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`titulo${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`titulo${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>

                    <b-button
                      variant="outline-success"
                      class="float-right mt-2 rounded-2"
                      v-if="k == 0"
                      @click="add('inputsEducacion')"
                    >
                      Agregar
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      class="float-right mt-2"
                      v-else-if="k > 0"
                      @click="remove('inputsEducacion', k)"
                    >
                      Remover
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>

            <div class="laboral">
              <h2 class="h2--title mt-4">Experiencia Laboral</h2>

              <div
                class="input-Laboral"
                v-for="(input, k) in experienciaLaborals"
                :key="k"
              >
                <hr />
                <b-row>
                  <b-col md="4" class="mt-1">
                    <div class="my-2">
                      <label>Empresa</label>
                      <input
                        class=" form-control"
                        type="text"
                        v-model="input.empresa"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralEmpr${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralEmpr${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div class="my-2">
                      <label>Salario RD$</label>
                      <input
                        class="  form-control"
                        type="number"
                        min="0"
                        v-model.number="input.salario"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralSalary${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralSalary${k}`)"
                        >El campo es obligatorio y numérico</span
                      >
                    </div>
                  </b-col>
                  <b-col md="4" class="mt-1">
                    <div class="my-2">
                      <label>Puesto</label>
                      <input
                        class="  form-control"
                        type="text"
                        v-model="input.puesto"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralJob${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralJob${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div class="my-2">
                      <label>Supervisor</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="input.supervisor"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralSuper${k}`"
                      />
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralSuper${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                  </b-col>

                  <b-col md="4" style="margin-top:0.7rem;">
                    <div class="mb-2">
                      <label>Fecha de Inicio</label>
                      <b-form-datepicker
                        locale="es"
                        placeholder="Fecha"
                        v-model="input.fechaInicio"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralIncio${k}`"
                      >
                      </b-form-datepicker>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralIncio${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>
                    <div>
                      <label>Fecha de Final</label>
                      <b-form-datepicker
                        locale="es"
                        placeholder="Fecha"
                        v-model="input.fechaFinal"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`laboralIncio${k}`"
                      >
                      </b-form-datepicker>
                      <span
                        class="text-danger fs-6"
                        v-show="errors.has(`laboralIncio${k}`)"
                        >El campo es obligatorio</span
                      >
                    </div>

                    <b-button
                      variant="outline-success"
                      class="float-right mt-2"
                      v-if="k == 0"
                      @click="add('inputsLaboral')"
                    >
                      Agregar
                    </b-button>
                    <b-button
                      class="float-right mt-2"
                      v-else-if="k > 0"
                      @click="remove('inputsLaboral', k)"
                      variant="outline-danger"
                    >
                      Remover
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- --------- -->
            <!-- Reference -->
            <!-- --------- -->
            <div class="referencias">
              <h2 class="h2--title mt-4">Referencias Personales</h2>
              <hr />
              <p>
                Por favor colocar 2 referencias que no correspondan a familiares
              </p>
              <template v-for="(input, k) in referencias">
                <b-row :key="k.id">
                  <b-col md="3">
                    <div class="my-2">
                      <label>Nombre completo</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="input.nombreCompleto"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`NombreRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`NombreRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="my-2">
                      <label>Dirección</label>
                      <input
                        class="  form-control"
                        type="text"
                        v-model="input.direccion"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`direccionRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`direccionRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="my-2">
                      <label>Teléfono</label>

                      <input
                        class="  form-control"
                        type="text"
                        v-model="input.telefono"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`telefonoRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`telefonoRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="my-2">
                      <label>Tiempo que se conocen</label>

                      <input
                        class=" form-control"
                        type="text"
                        v-model="input.tiempoConociendolo"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`tiempoRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`tiempoRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </div>

           <!---- ------------ ---------->
           <!---- Referencias Laborales-->
           <!---- ------------ ---------->

           <div class="referencias">
              <h2 class="h2--title mt-4">Referencias Laborales</h2>
              <hr />
              <p>
                Por favor colocar 3 referencias laborales
              </p>
              <template v-for="(input, k) in referenciasLabs">
                <b-row :key="k.id">
                  <b-col md="3">
                    <div class="my-2">
                      <label>Nombre completo</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="input.nombreCompleto"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`NombreRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`NombreRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="my-2">
                      <label>Cargo</label>
                      <input
                        class="  form-control"
                        type="text"
                        v-model="input.cargo"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`cargoRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`direccionRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3">
                    <div class="my-2">
                      <label>Teléfono</label>

                      <input
                        class="  form-control"
                        type="text"
                        v-model="input.telefono"
                        v-validate="'required'"
                        data-vv-validate-on="blur|input"
                        :data-vv-name="`telefonoRef${k}`"
                      />
                      <div>
                        <span
                          class="text-danger fs-6"
                          v-show="errors.has(`telefonoRef${k}`)"
                          >El campo es obligatorio</span
                        >
                      </div>
                    </div>
                  </b-col>
                
                </b-row>
              </template>
            </div>

            <!-- --------- -->
            <!-- Person -->
            <!-- --------- -->
            <div class="">
              <hr />
              <b-row>
                <b-col md="6">
                  <h3 class="subtitulo mt-4">
                    Nombre de parientes que laboran en Referencia, actual o
                    anteriores <span class="">(Opcional)</span>
                  </h3>
                  <div
                    class="container__buttonInput"
                    v-for="(input, k) in parientes"
                    :key="input.id"
                  >
                    <input
                      class="my-2  form-control"
                      type="text"
                      v-model="input.nombreCompleto"
                      placeholder="Nombre completo"
                    />
                    <div v-if="k == 0">
                      <b-button
                        variant="outline-success"
                        class="float-right ml-2 mt-2 btn btn-outline-success"
                        @click="add('inputsParienteRef')"
                      >
                        Agregar
                      </b-button>
                    </div>

                    <div v-else-if="k > 0">
                      <b-button
                        variant="outline-danger"
                        class="float-right ml-2 mt-2 "
                        @click="remove('inputsParienteRef', k)"
                      >
                        Remover
                      </b-button>
                    </div>
                  </div>
                </b-col>
                <b-col md="6">
                  <h3 class="subtitulo mt-4">
                    Nombre de amigos que laboran en Referencia
                    <span class="">(Opcional)</span>
                  </h3>
                  <div
                    class="container__buttonInput"
                    v-for="(input, k) in amigos"
                    :key="input.id"
                  >
                    <input
                      class="my-2  form-control"
                      type="text"
                      v-model="input.nombreCompleto"
                      placeholder="Nombre completo"
                    />
                    <div v-if="k == 0">
                      <b-button
                        variant="outline-success"
                        class="float-right ml-2 mt-2 btn btn-outline-success"
                        @click="add('inputsAmigosRef')"
                      >
                        Agregar
                      </b-button>
                    </div>

                    <div v-else-if="k > 0">
                      <b-button
                        variant="outline-danger"
                        class="float-right ml-2 mt-2 btn btn-outline-danger"
                        @click="remove('inputsAmigosRef', k)"
                      >
                        Remover
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div>
              <h3 class="subtitulo mt-4">
                ¿Quién lo recomienda? (Opcional)
              </h3>
              <input
                class="my-2  form-control"
                type="text"
                v-model="solicitud.recomendacion"
              />
              <div>
                <h3 class="subtitulo mt-4">
                  ¿Qué trabajo o área prefiere?
                </h3>
                <input
                  class="my-2  form-control"
                  type="text"
                  v-model="solicitud.areaPrefiere"
                  v-validate="'required'"
                  data-vv-validate-on="blur|input"
                  data-vv-name="area"
                />
                <div>
                  <span class="text-danger fs-6" v-show="errors.has('area')"
                    >El campo es obligatorio</span
                  >
                </div>
              </div>
            </div>
            <div>
              <h3 class="subtitulo mt-4">
                ¿Cuáles equipos y softwares de computadora maneja?
              </h3>
              <div
                class="container__buttonInput"
                v-for="(input, k) in equipoSoftwares"
                :key="input.id"
              >
                <input
                  class="my-2  form-control"
                  type="text"
                  v-model="input.descripcion"
                  placeholder="Nombre"
                />
                <div v-if="k == 0">
                  <b-button
                    variant="outline-success"
                    class="float-right ml-2 mt-2 btn btn-outline-success"
                    @click="add('inputSoftware')"
                  >
                    Agregar
                  </b-button>
                </div>

                <div v-else-if="k > 0">
                  <b-button
                    variant="outline-danger"
                    class="float-right ml-2 mt-2 btn btn-outline-danger"
                    @click="remove('inputSoftware', k)"
                  >
                    Remover
                  </b-button>
                </div>
              </div>
            </div>

            <div>
              <h2 class="h2--title mt-4">Idiomas</h2>
              <div>
                <label> ¿Usted sabe otro idioma además del español?</label>
                <input class="ml-2" type="checkbox" v-model="hasIdioma" />
              </div>
              <template v-if="hasIdioma">
                <div v-for="(input, k) in idiomas" :key="input.id">
                  <hr />
                  <div class="">
                    <label>Idioma</label>
                    <input
                      class="mb-2  form-control"
                      type="text"
                      v-validate="'required'"
                      v-model="input.nombre"
                      data-vv-validate-on="blur|input"
                      :data-vv-name="`idioma${k}`"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has(`idioma${k}`)"
                      >El campo es obligatorio</span
                    >
                  </div>
                  <b-row>
                    <b-col md="4">
                      <label class="">Lectura</label>
                      <select
                        v-model="input.lectura"
                        class="form-control"
                        aria-label="Default select"
                      >
                        <option
                          v-for="tipo in opcionesNivelIdioma"
                          :value="tipo.value"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                    </b-col>
                    <b-col md="4">
                      <label class="">Escritura</label>
                      <select
                        v-model="input.escritura"
                        class="form-control"
                        aria-label="Default select"
                      >
                        <option
                          v-for="tipo in opcionesNivelIdioma"
                          :value="tipo.value"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                    </b-col>
                    <b-col md="4">
                      <label class="">Habla</label>
                      <select
                        v-model="input.habla"
                        class="form-control"
                        aria-label="Default select"
                      >
                        <option
                          v-for="tipo in opcionesNivelIdioma"
                          :value="tipo.value"
                          :key="tipo.id"
                        >
                          {{ tipo.text }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <div class="mb-4">
                    <div class="text-right" v-if="k == 0">
                      <b-button
                        variant="outline-success"
                        class=" mt-2 btn btn-outline-success"
                        @click="add('inputIdiomas')"
                      >
                        Agregar
                      </b-button>
                    </div>

                    <div v-else-if="k > 0" class="text-right">
                      <b-button
                        variant="outline-danger"
                        class="mt-2 btn btn-outline-danger "
                        @click="remove('inputIdiomas', k)"
                      >
                        Remover
                      </b-button>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div>
              <h2 class="h2--title mt-4">
                ¿Posee vehículos? <input type="checkbox" v-model="hasVehicle" />
              </h2>

              <b-row class="mt-2" v-if="hasVehicle">
                <b-col md="6">
                  <div class="my-2">
                    <label>Marca</label>
                    <input
                      class=" form-control"
                      type="text"
                      v-model="vehiculo.marca"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="marca"
                    />
                    <span class="text-danger fs-6" v-show="errors.has('marca')"
                      >El campo es obligatorio</span
                    >
                  </div>
                  <div class="my-2">
                    <label>Tipo</label>
                    <input
                      class="  form-control"
                      type="text"
                      v-model="vehiculo.tipo"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="tipo"
                    />
                    <span class="text-danger fs-6" v-show="errors.has('tipo')"
                      >El campo es obligatorio</span
                    >
                  </div>
                  <div class="my-2">
                    <label>Año</label>
                    <input
                      class="  form-control"
                      type="number"
                      min="1970"
                      v-model="vehiculo.ano"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="ano"
                    />
                    <span class="text-danger fs-6" v-show="errors.has('ano')"
                      >El campo es obligatorio</span
                    >
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="my-2 ">
                    <label>No. Licencia</label>
                    <input
                      class=" form-control"
                      type="text"
                      v-model="vehiculo.licencia"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="licencia"
                      placeholder=""
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('licencia')"
                      >El campo es obligatorio</span
                    >
                  </div>
                  <div class="my-2">
                    <label>Categoría</label>
                    <input
                      class=" form-control"
                      type="text"
                      v-model="vehiculo.categoria"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      data-vv-name="categoria"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has('categoria')"
                      >El campo es obligatorio</span
                    >
                  </div>
                  <div class="my-2">
                    <label>Fecha de vencimiento"</label>
                    <b-form-datepicker
                      locale="es"
                      class=" form-control"
                      v-model="vehiculo.fechaVencimiento"
                      v-validate="'required'"
                      placeholder="Fecha"
                      data-vv-validate-on="blur|input"
                      data-vv-name="fechaVencimiento"
                    />
                    <span class="text-danger fs-6" v-show="errors.has('ano')"
                      >El campo es obligatorio</span
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
            <div>
              <h2 class="h2--title mt-4">
                En caso de emergencia notifícamos a:
              </h2>

              <b-row
                class="mt-2"
                v-for="(input, k) in emergencias"
                :key="input.id"
              >
                <b-col md="4">
                  <div class="my-2">
                    <label>Nombre</label>
                    <input
                      class="  form-control"
                      type="text"
                      v-model="input.nombreCmpleto"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      :data-vv-name="`nombreEm${k}`"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has(`nombreEm${k}`)"
                      >El campo es obligatorio</span
                    >
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="my-2">
                    <label>Teléfono</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="input.telefono"
                      v-validate="'required'"
                      data-vv-validate-on="blur|input"
                      :data-vv-name="`telefonoEm${k}`"
                    />
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has(`telefonoEm${k}`)"
                      >El campo es obligatorio</span
                    >
                  </div>
                </b-col>
                <b-col md="4" class="my-2 ">
                  <label>Parentesco</label>
                  <select
                    class="form-control"
                    aria-label="Default select"
                    v-model="input.parentesco"
                    v-validate="'required'"
                    data-vv-validate-on="blur|input"
                    :data-vv-name="`parentescoEm${k}`"
                  >
                    <option
                      v-for="tipo in opcionesPatentesco"
                      :value="tipo.text"
                      :key="tipo.id"
                    >
                      {{ tipo.text }}
                    </option>
                  </select>
                  <div>
                    <span
                      class="text-danger fs-6"
                      v-show="errors.has(`parentescoEm${k}`)"
                      >El campo es obligatorio</span
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="text-right">
              <b-button variant="success" class=" mt-4" type="submit"
                >Enviar Solicitud</b-button
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import {
  MES,
  ESTADO_CIVIL,
  PARENTESCO,
  SANGRE,
  NIVEL_EDUCATIVO,
  NIVEL_IDIOMA,
  NACIONALIDADES,
} from "../utils/constants";

Validator.extend("validDocument", {
  validate: (document, tipo) => {
    var doc = tipo[0];
    if (doc == "Pasaporte" && document.length > 0) {
      return true;
    } else if (doc == "Cedula" && document.length > 10) {
      return true;
    }
    return false;
  },
  options: { hasTarget: true },
});

Validator.extend("validFechaNacimiento", {
  validate: (date) => {
    var dayNow = new Date();
    var birthday = new Date(date);
    var diff = Math.floor(dayNow.getTime() - birthday.getTime());
    var day = 1000 * 60 * 60 * 24;
    var days = Math.floor(diff / day);
    var months = Math.floor(days / 31);
    var years = Math.floor(months / 12);
    if (years >= 8) {
      return true;
    }
    return false;
  },
});

export default {
  name: "Formulario",

  data() {
    return {
      opcionesPatentesco: PARENTESCO,
      opcionesEstadoCivil: ESTADO_CIVIL,
      opcionesSangre: SANGRE,
      opcionesMes: MES,
      opcionesNivel: NIVEL_EDUCATIVO,
      opcionesNivelIdioma: NIVEL_IDIOMA,
      arrayPaises: [],
      arrayNacionalidad: NACIONALIDADES,
      listVacants: [],
      hasIdioma: false,
      solicitud: {
        id: 0,
        tipoDocumento: "Cedula",
        documento: "",
        nombre: "",
        apellido: "",
        celular: "",
        telefono: "",
        correo: "",
        sexo: "M",
        tipoSangre: "A+",
        estadoCivil: "Soltero",
        fechaNacimento: null,
        lugarNacimiento: "",
        pais: "",
        direccion: "",
        areaPrefiere: "",
        recomendacion: "",
        estatusVerificacion: "",
        estatusSolicitud: "",
        nacionalidad: "",
        vacanteId: null,
      },

      familias: [
        {
          nombreCompleto: "",
          edad: null,
          parentesco: "",
          ocupacion: "",
          fechaNacimiento: new Date(),
        },
      ],
      educacion: [
        {
          nombreInstitucion: "",
          fechaInicio: new Date(),
          fechaFinal: new Date(),
          titulo: "",
          nivelAcademico: "",
        },
      ],
      hasVehicle: false,
      vehiculo: {
        marca: "",
        tipo: "",
        ano: "",
        licencia: "",
        categoria: "",
        fechaVencimiento: new Date(),
      },
      experienciaLaborals: [
        {
          empresa: "",
          salario: null,
          puesto: "",
          fechaInicio: new Date(),
          fechaFinal: new Date(),
          supervisor: "",
        },
      ],

      referencias: [
        {
          nombreCompleto: "",
          direccion: "",
          telefono: "",
          tiempoConociendolo: "",
        },
        
        {
          nombreCompleto: "",
          direccion: "",
          telefono: "",
          tiempoConociendolo: "",
        },
      ],

      referenciasLabs: [
        {
          nombreCompleto: "",
          cargo: "",
          telefono: "",
          
        },
        
        {
          nombreCompleto: "",
          cargo: "",
          telefono: "",
        },

        {
          nombreCompleto: "",
          cargo: "",
          telefono: "",
        },
      ],

      parientes: [
        {
          nombreCompleto: "",
        },
      ],
      amigos: [{ nombreCompleto: "" }],
      equipoSoftwares: [{ descripcion: "" }],
      idiomas: [
        {
          nombre: "",
          lectura: "Básico",
          escritura: "Básico",
          habla: "Básico",
        },
      ],

      emergencias: [
        {
          nombreCmpleto: "",
          telefono: "",
          parentesco: "Madre",
        },
        {
          nombreCmpleto: "",
          telefono: "",
          parentesco: "Padre",
        },
      ],
    };
  },

  computed:{
    filteredCountries() {
      return this.arrayPaises.filter(country => /^[A-Z]/.test(country));
    },
    sortedCountries() {
      return this.filteredCountries.sort((a, b) => a.localeCompare(b));
    }
  },
  async mounted() {
    await this.ApiPaises();
    await this.getVacants();
    this.loadForm();
  },
  methods: {
    async ApiPaises() {
      try {
        const res = await fetch("https://countriesnow.space/api/v0.1/countries/population");
       // const res = await fetch("https://restcountries.eu/rest/v2/all");
        const data = await res.json();
        const arrayNombre = data.data.map((element) => element.country);
        //const arrayNacionalidad = data.map((element) => element.demonym);
        this.arrayPaises = arrayNombre;
        //this.arrayNacionalidad = arrayNacionalidad;
      } catch (error) {
        console.log(error);
      }
    },
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          var data = {
            solicitud: this.solicitud,
            familias: this.familias,
            educacion: this.educacion,
            hasVehicle: this.hasVehicle,
            vehiculo: this.hasVehicle ? this.vehiculo : null,
            experienciaLaborals: this.experienciaLaborals,
            referencias: this.referencias,
            referenciasLabs: this.referenciasLabs,
            parientes: this.parientes,
            amigos: this.amigos,
            equipoSoftwares: this.equipoSoftwares,
            idiomas: this.hasIdioma ? this.idiomas : [],
            emergencias: this.emergencias,
          };
          if (this.solicitud.id == 0) {
            this.$loading.show();
            this.$store
              .dispatch({ type: "applyEmployer/createApplication", data })
              .then((resp) => {
                this.$loading.hide();
                this.$swal.fire("Éxito", `${resp.message}`, "success");
                this.solicitud = resp.response;
              })
              .catch((e) => {
                this.$loading.hide();
                this.$swal.fire("Error", e.message, "error");
              });
          } else {
            this.$loading.show();
            this.$store
              .dispatch({ type: "applyEmployer/updateApplication", data })
              .then((resp) => {
                this.$loading.hide();
                this.$swal.fire("Éxito", `${resp.message}`, "success");
              })
              .catch((e) => {
                this.$loading.hide();
                this.$swal.fire("Error", e.message, "error");
              });
          }
        } else {
          this.$swal.fire(
            "Error",
            "Verificar los campos que son oblicatorio",
            "error"
          );
        }
      });
    },

    add(clave) {
      if (clave == "inputsFamilia")
        this.familias.push({
          parentesco: "Hermano/a",
          edad: null,
          nombreCompleto: "",
          ocupacion: "",
          fechaNacimiento: "",
        });
      else if (clave == "inputsEducacion") {
        this.educacion.push({
          nombreInstitucion: "",
          titulo: "",
          fechaInicio: new Date(),
          fechaFinal: new Date(),
          nivelAcademico: "Bachiller",
        });
      } else if (clave == "inputsLaboral") {
        this.experienciaLaborals.push({
          empresa: "",
          salario: null,
          puesto: "",
          fechaInicio: new Date(),
          fechaFinal: new Date(),
          supervisor: "",
        });
      } else if (clave == "inputsParienteRef") {
        this.parientes.push({
          nombreCompleto: "",
        });
      } else if (clave == "inputsAmigosRef") {
        this.amigos.push({
          nombreCompleto: "",
        });
      } else if (clave == "inputSoftware") {
        this.equipoSoftwares.push({
          descripcion: "",
        });
      } else if (clave == "inputIdiomas") {
        this.idiomas.push({
          idioma: "",
          lectura: "Básico",
          escritura: "Básico",
          habla: "Básico",
        });
      }
    },

    remove(clave, index) {
      if (clave == "inputsFamilia") {
        this.familias.splice(index, 1);
      } else if (clave == "inputsEducacion") {
        this.educacion.splice(index, 1);
      } else if (clave == "inputsLaboral") {
        this.experienciaLaborals.splice(index, 1);
      } else if (clave == "inputsParienteRef") {
        this.parientes.splice(index, 1);
      } else if (clave == "inputsAmigosRef") {
        this.amigos.splice(index, 1);
      } else if (clave == "inputSoftware") {
        this.equipoSoftwares.splice(index, 1);
      } else if (clave == "inputIdiomas") {
        this.idiomas.splice(index, 1);
      }
    },
    loadForm() {
      this.$store
        .dispatch({ type: "applyEmployer/getApplicationCurrentUser" })
        .then((resp) => {
          if (resp.response != null) {
            this.solicitud = resp.response.solicitud;
            this.familias = resp.response.familias;
            this.educacion = resp.response.educacion;
            this.hasVehicle = resp.response.hasVehicle;
            this.vehiculo = this.hasVehicle
              ? resp.response.vehiculo
              : this.vehiculo;
            this.referencias = resp.response.referencias;
            this.referenciasLabs = resp.response.referenciasLabs;
            this.experienciaLaborals = resp.response.experienciaLaborals;
            this.parientes = resp.response.parientes;
            this.amigos = resp.response.amigos;
            this.equipoSoftwares = resp.response.equipoSoftwares;
            this.idiomas =
              resp.response.idiomas.length == 0
                ? this.idiomas
                : resp.response.idiomas;
            this.hasIdioma = resp.response.idiomas.length > 0;
            this.emergencias = resp.response.emergencias;
          }
        });
    },

    async getVacants() {
      this.listVacants.push({ id: null, departamento: "", vacante: "" });
      const resp = await this.$store.dispatch({
        type: "vacant/getListVacantAvailable",
      });

      this.listVacants.push(...resp);
    },
  },
};
</script>

<style>
.container__buttonInput {
  display: flex;
}

.subtitulo {
  font-size: 1.1rem;
  color: #b7b8b9;
}

.textform {
  margin-bottom: 3px;
}

.form {
  border: 10px;
}

.panel {
  padding: 20px;
}

.applyForm {
  background: #ffffff;
  padding: 10px;
  -webkit-box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
  -moz-box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
  box-shadow: 0px 0px 13px -1px rgba(0, 0, 0, 0.34);
}

.container--btn {
  display: flex;
  justify-content: space-between;
}

.date__input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>
